export const WEBSITE_PAGE_TYPES = {
  WEDDING_PARTY: 'WEDDING_PARTY',
  POI: 'POI',
  FAQ: 'FAQ',
  TRAVEL: 'TRAVEL',
  REGISTRY: 'REGISTRY',
  PHOTO: 'PHOTO',
  HOME: 'HOME',
  EVENT: 'EVENT',
  RSVP: 'RSVP',
};

export enum PAGE_TYPES_ENUM {
  WEDDING_PARTY = 'WEDDING_PARTY',
  POI = 'POI',
  FAQ = 'FAQ',
  TRAVEL = 'TRAVEL',
  REGISTRY = 'REGISTRY',
  PHOTO = 'PHOTO',
  HOME = 'HOME',
  EVENT = 'EVENT',
  RSVP = 'RSVP',
}
